<bfa-modal isVisible="isPreviewerVisible" [enableBackdrop]="true" [enableClose]="true" width="{{ this.landscape ? '850px' : '800px' }}" (isVisibleChange)="onClose($event)">
	<iframe [attr.id]="REPORT_CONTAINER"></iframe>
	<div class="actions" *ngIf="pages">
		<button dz-button (click)="generate()">Generate</button>
	</div>
</bfa-modal>
